import React, { useState, useEffect } from "react";
import axios from "axios";

import { Container, Card, Form, Row, Spinner } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";

import { toast } from "react-toastify";
import { STUDENT_FINAL_ASSIGNMENT_API } from "../../../api/api";

import { handleApiError } from "../../../utils/apiErrorHandler";

import "./StudentFinalAssignmentResult.css";

const StudentFinalAssignmentResult = () => {
  const navigate = useNavigate();
  const { finalAssignmentId } = useParams();

  const [questions, setQuestions] = useState([]);
  const [feedback, setFeedback] = useState("");

  //loading
  const [loadingFinalAssignmentResult, setFinalAssignmentResultLoading] =
    useState(true);

  // main toast error
  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      setFinalAssignmentResultLoading(false);
      navigate("/signin");

      return;
    }

    const fetchFinalAssignmentResult = async () => {
      try {
        const response = await axios.post(
          STUDENT_FINAL_ASSIGNMENT_API.GET_FINAL_EXAM_RESULT,
          { final_assignment_id: finalAssignmentId },
          { headers: { Authorization: `Bearer ${token}` } },
        );

        const data = response.data;

        if (data.statusCode === 200) {
          const formattedQuestions = (data.data || []).map((q, idx) => ({
            finalAssignmentQuestionId: q.final_assignment_question_id,
            question: q.question,
            options: [
              { key: "a", value: q.a },
              { key: "b", value: q.b },
              { key: "c", value: q.c },
              { key: "d", value: q.d },
            ],
            index: idx + 1,
            correctAnswer: q.answer,
            selectedAnswer: q.student_answer || "",
            isCorrect: q.is_correct,
          }));

          setQuestions(formattedQuestions);
          setFeedback(data.feedback || "");
        } else {
          // This will handle any 2xx response that is not 201
          showErrorToast(data.message);
        }
      } catch (error) {
        console.error(error);
        // Server responded with non-2xx status (like 400, 500)

        // CHECK (expiry / invalid token)
        if (error.response?.status === 404) {
          setTimeout(() => {
            navigate("/student/assignments");
          }, 1000);
          return; // ← handle 404 separately
        }
        handleApiError(error, navigate, showErrorToast, "/signin");
      } finally {
        setFinalAssignmentResultLoading(false);
      }
    };

    fetchFinalAssignmentResult();
  }, [finalAssignmentId, navigate]);

  // Score Calculation
  const score = questions.filter((q) => q.isCorrect).length;

  return (
    <Container fluid className="student-certificate-section-container">
      {loadingFinalAssignmentResult ? (
        <div className="text-center mt-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div className="student-assignment-result-page">
          <div className="student-assignment-result-header">
            <div className="student-dashboard-backmoving-button-wrapper">
              <button
                className="student-dashboard-backmoving-button-main"
                onClick={() => navigate(-1)}
              >
                <IoArrowBack className="student-dashboard-backmoving-button-icon" />
                <span className="student-dashboard-backmoving-button-text">
                  Back
                </span>
              </button>
            </div>

            <Row className="align-items-center mb-2">
              <h2 className="student-certificate-section-title">
                Final Assignment Result
              </h2>
              <p className="student-certificate-section-description mt-2">
                Total Score: {score} / {questions.length}
              </p>

              {feedback && (
                <p className="student-certificate-section-description mt-2">
                  <span className="student-certificate-section-feedback">
                    Tutor Feedback:
                  </span>{" "}
                  {feedback}
                </p>
              )}
            </Row>
          </div>

          <div className="student-assignment-result-body">
            <Card className="student-assignmentcomplete-details-card">
              {questions.map((q) => (
                <div
                  key={q.finalAssignmentQuestionId}
                  className={`student-assignmentcomplete-details-question-box
             ${q.isCorrect ? "student-assignmentcomplete-correct" : "student-assignmentcomplete-wrong"}`}
                >
                  <div className="student-assignmentcomplete-details-question-title">
                    {q.index}. {q.question}
                  </div>

                  <Form>
                    {q.options.map((opt) => (
                      <Form.Check
                        key={opt.key}
                        type="radio"
                        // name={`question-${q.id}`}
                        label={opt.value}
                        checked={q.selectedAnswer === opt.key}
                        disabled
                        className="student-assignmentcomplete-details-option"
                      />
                    ))}
                  </Form>

                  {!q.isCorrect && (
                    <div className="correct-assignmentcomplete-text">
                      Correct Answer: {q.correctAnswer}
                    </div>
                  )}
                </div>
              ))}
            </Card>
          </div>
        </div>
      )}
    </Container>
  );
};

export default StudentFinalAssignmentResult;
